import React, { 
  useState, 
  useEffect,
  useRef
} from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Segmented } from 'antd'

export const EventsMenu = (props) => {

  const params = useParams()
  const eventType = params.eventType || props.eventType
  const eventId = params.eventId || props.eventId
  const { events } = props
  const [ current, setCurrent ] = useState(eventId)
  const [ segments, setSegments ] = useState()
  const navigate = useNavigate()
  const menuRef = useRef()
  const menuDragRef = useRef()

  useEffect(() => {

    if (!events) return

    const segments = events.map(event => {
      return {
        label: event.title,
        value: event.eventId.toString(),
        disabled: !event.instance.start
      }
    })

    setSegments(segments)

  }, [events])


  const onChange = (value) => {
    // navigate(`/game/${props.type || 'events'}/${eventType}/${value}`)
    navigate(value)
  };

  const dragControl = (event, data) => {

    const menubounds = menuRef.current.getBoundingClientRect()
    const dragbounds = menuDragRef.current.getBoundingClientRect()

    console.log('----------------------')
    console.log(menubounds.width)
    console.log(dragbounds.width)

    return data.position.left <= 0    
           && 
           data.position.left > (menubounds.width - dragbounds.width)
  }

  useEffect(() => {

    if(menuDragRef.current) {
      
      jQuery(menuDragRef.current)
      .draggable({
        axis: 'x',
        drag: dragControl
      })
    }

  }, [menuDragRef])

  return <div 
    className="menu"
    ref={ menuRef }
  >
    <div 
      className="menudrag"
      ref={ menuDragRef }
    >
      <Segmented
        block={false}
        value={eventId}
        onChange={onChange}
        options={segments}
      />
    </div>
  </div>
}
